import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const setResetPasswordStatus = create(actions.SET_RESET_PASSWORD_STATUS);
export const startResetPassword = create(actions.START_RESET_PASSWORD);